import { jsPDF } from 'jspdf';
import { format } from 'date-fns';

interface PdfOptions {
  userName: string;
  readingType: string;
  predictionText: string;
  birthDetails: {
    dob: string;
    birthTime: string;
    birthPlace: string;
  };
}

export const generatePdfReport = (options: PdfOptions): string => {
  const { userName, readingType, predictionText, birthDetails } = options;
  
  // Create a new PDF document
  const doc = new jsPDF();
  
  // Add header
  doc.setFontSize(22);
  doc.setTextColor(103, 58, 183); // Primary color
  doc.text('AI Pandit Ji', 105, 20, { align: 'center' });
  
  // Add website URL
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  doc.text('https://theaipanditji.com', 105, 28, { align: 'center' });
  
  // Add subtitle
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
  doc.text(`${readingType.charAt(0).toUpperCase() + readingType.slice(1)} Reading`, 105, 38, { align: 'center' });
  
  // Add date
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  doc.text(`Generated on: ${format(new Date(), 'MMMM dd, yyyy')}`, 105, 46, { align: 'center' });
  
  // Add user details
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);
  doc.text(`Name: ${userName}`, 20, 58);
  doc.text(`Date of Birth: ${birthDetails.dob}`, 20, 66);
  doc.text(`Birth Time: ${birthDetails.birthTime}`, 20, 74);
  doc.text(`Birth Place: ${birthDetails.birthPlace}`, 20, 82);
  
  // Add a divider
  doc.setDrawColor(103, 58, 183); // Primary color
  doc.setLineWidth(0.5);
  doc.line(20, 88, 190, 88);
  
  // Add the prediction text
  doc.setFontSize(11);
  doc.setTextColor(0, 0, 0);
  
  // Handle text wrapping by splitting the text into lines
  const textLines = doc.splitTextToSize(predictionText, 170);
  let y = 98;
  
  textLines.forEach((line: string) => {
    // If we've reached the bottom of the page, add a new page
    if (y > 280) {
      doc.addPage();
      y = 20;
    }
    
    doc.text(line, 20, y);
    y += 7;
  });
  
  // Add footer
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  const pageCount = (doc.internal as any).getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.text(`AI Pandit Ji - Your Personal AI Astrologer`, 105, 285, { align: 'center' });
    doc.text(`Page ${i} of ${pageCount}`, 105, 292, { align: 'center' });
  }
  
  // Return the PDF as a data URL
  return doc.output('dataurlstring');
};